var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ItemAudiences item-detail d-flex flex-row align-center",class:{ small: _vm.small }},[_c('Target'),_c('span',{staticClass:"ml-1 text-truncate"},[_vm._v(_vm._s(_vm.audienceCaption))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }